@if (type === loaderType.button) {
<div class="dots-loading">
  <span class="dot"></span>
  <span class="dot"></span>
  <span class="dot"></span>
</div>
}
@if (type === loaderType.page) {
<div fxLayout="row" fxLayoutAlign="center center">
  <div class="pg-loading-container">
    <div class="pg-loader"></div>
    <div class="pg-loading-text">Loading...</div>
    <div class="pg-loading-sub-text">Please wait while we fetch your data.</div>
  </div>
</div>
}